
import React from 'react'
import { Row, Col, Badge } from 'react-bootstrap'
import { Field } from 'redux-form'
import { renderTextField } from '../../../Forms/fieldRenderers'
// import ConsultaPorCodigoDeCupo from '../../../Cupos/components/ConsultaPorCodigoDeCupo'

function CamposIngresoCompleto0 (props) {
  const { handleSubmit, onPrinterChange, printerName, cpaTextValue, onChange } = props

  return (
    <form onSubmit={handleSubmit}>
      <Row style={{ alignItems: 'center', margin: '4% 0' }}>
        <Col md={4}>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Field
              name='numero'
              type='text'
              label='Nº de CTG en CP Electrónica'
              value={cpaTextValue}
              component={renderTextField}
              placeholder='10200000000'
              onChange={onChange}
            />
            <p
              style={{ textAlign: 'left', margin: '0', float: 'left' }}
              className='box-info'
            >
              Ingrese una carta de porte actualizar sus datos
            </p>
          </div>
        </Col>
        {/* <Col md={5}>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <ConsultaPorCodigoDeCupo
              textLabel='Ingrese el código de cupo'
              autoFocus={false}
            />
            <p
              style={{ textAlign: 'left', margin: '0 12px', float: 'left' }}
              className='box-info'
            >
              Ingrese un código de cupo para ingresar una carta de porte
            </p>
          </div>
        </Col> */}
        <Col md={1}>
          {printerName
            ? <Badge
              variant='secondary'
              style={{ padding: '8px' }}
              onClick={onPrinterChange}
            >
                [ Cambiar {printerName} ]
            </Badge>
            : null
          }
        </Col>
      </Row>
    </form>
  )
}

export default CamposIngresoCompleto0
